module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vue-loader-autoprefix-161.vue");


//////////////////
// WEBPACK FOOTER
// ./en/development/vue-loader-autoprefix.md
// module id = 577
// module chunks = 215